export default __webpack_public_path__ + "static/media/headerBack.6fe37565.svg";